import React, { useState } from 'react';
import { IconCheckmark, IconCopy } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './PromoCodeButton.styles';

const COPIED_MESSAGE_DURATION = 1000;

export interface PromoCodeButtonProps {
  promoCode: string;
}

export const PromoCodeButton = ({ promoCode }: PromoCodeButtonProps) => {
  const [copied, setCopied] = useState<boolean>(false);

  const onButtonClick = async () => {
    try {
      await navigator.clipboard.writeText(promoCode);
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_MESSAGE_DURATION);
    } catch (error) {
      console.error('Failed to copy to clipboard', error);
    }
  };

  return (
    <button
      aria-label="Copy promo code to clipboard"
      css={styles.root}
      onClick={onButtonClick}
      type="button"
    >
      {copied ? (
        <>
          Copied code <IconCheckmark color="currentColor" height={16} width={16} />
        </>
      ) : (
        <>
          {promoCode}
          <IconCopy color="currentColor" height={16} width={16} />
        </>
      )}
    </button>
  );
};
